import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import './RecentAddedBooks.css';
import noBookCover from '../assets/no-book-cover.png'; // Import local placeholder image
import config from '../config'; // Import config for API_URL

function RecentAddedBooks() {
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const API_URL = config.API_URL; // Use config for API_URL
    const history = useHistory();

    useEffect(() => {
        const fetchRecentBooks = async () => {
            try {
                const res = await axios.get(`${API_URL}api/books/allbooks`);
                // Get the 5 most recent books
                const recentBooks = res.data.slice(0, 5);
                setBooks(recentBooks);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching recent books:', err);
                setLoading(false);
            }
        };

        fetchRecentBooks();
    }, [API_URL]);

    const handleViewAllBooks = (e) => {
        e.preventDefault();
        history.push('/books');
    };

    if (loading) {
        return <div className="recent-books-loading">Loading recent books...</div>;
    }

    return (
        <div className="recent-books-container">
            <h2 className="recent-books-title">Recently Added Books</h2>
            <div className="recent-books-grid">
                {books.map(book => (
                    <Link to={`/books/${book._id}`} key={book._id} className="recent-book-card">
                        <div className="recent-book-image">
                            <img 
                                src={book.imageUrl || noBookCover} 
                                alt={book.bookName}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = noBookCover;
                                }}
                            />
                        </div>
                        <div className="recent-book-info">
                            <h3>{book.bookName}</h3>
                            <p className="author">By {book.author}</p>
                            <p className="added-date">Added: {new Date(book.createdAt).toLocaleDateString()}</p>
                        </div>
                    </Link>
                ))}
            </div>
            <button onClick={handleViewAllBooks} className="view-all-books">
                View All Books
            </button>
        </div>
    );
}

export default RecentAddedBooks;